"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormSkeletonSubscribe = exports.usePreviousConditioned = exports.usePrevious = void 0;

var _react = require("react");

/**
 * Store previous value of one variable
 * @param {any} value - variable to save
 */
var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};
/**
 * Store previous value of one variable, value only changes if update param it's true
 * @param {any} value - variable to save
 */


exports.usePrevious = usePrevious;

var usePreviousConditioned = function usePreviousConditioned(value, update) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (update) {
      ref.current = value;
    }
  }, [value, update]);
  return ref.current;
};

exports.usePreviousConditioned = usePreviousConditioned;

var useFormSkeletonSubscribe = function useFormSkeletonSubscribe(activateFormElement, deactivateFormElement) {
  (0, _react.useEffect)(function () {
    if (activateFormElement) {
      activateFormElement();
    }

    return function () {
      if (deactivateFormElement) {
        deactivateFormElement();
      }
    };
  }, [activateFormElement, deactivateFormElement]);
};

exports.useFormSkeletonSubscribe = useFormSkeletonSubscribe;

//# sourceMappingURL=index.js.map